import React from "react";

export function ProjectsTable({ projects }) {
    if (!projects.length) {
        return (
            <div className="text-sm text-slate-500 py-8 text-center border border-dashed border-[#2A3655] rounded-sm">
                No projects match.
            </div>
        );
    }
    return (
        <div
            className="overflow-x-auto overscroll-x-contain rounded-sm border border-[#2A3655]"
            style={{ touchAction: "pan-x pan-y", WebkitOverflowScrolling: "touch" }}
            data-testid="admin-projects-table-scroll"
        >
            <table
                className="min-w-[720px] w-full text-[13px]"
                data-testid="admin-projects-table"
            >
                <thead className="bg-[#0F1B3A] text-[10px] uppercase tracking-wider text-slate-400">
                    <tr>
                        <th className="text-left px-3 py-2">Name</th>
                        <th className="text-left px-3 py-2">Owner</th>
                        <th className="text-left px-3 py-2">Unit</th>
                        <th className="text-left px-3 py-2">Created</th>
                        <th className="text-left px-3 py-2">ID</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-[#1C253C]">
                    {projects.map((p) => (
                        <tr
                            key={p.id}
                            data-testid={`admin-project-row-${p.id}`}
                            className="hover:bg-[#1C253C]"
                        >
                            <td className="px-3 py-2 text-white whitespace-nowrap">
                                {p.name || "Untitled"}
                            </td>
                            <td className="px-3 py-2 text-slate-300 whitespace-nowrap">
                                {p.owner_email || p.user_id}
                            </td>
                            <td className="px-3 py-2 text-[11px] uppercase tracking-wider text-slate-400 whitespace-nowrap">
                                {p.unit_system || "imperial"}
                            </td>
                            <td className="px-3 py-2 text-slate-400 tabular-nums whitespace-nowrap">
                                {(p.created_at || "").slice(0, 10)}
                            </td>
                            <td className="px-3 py-2 text-slate-500 tabular-nums text-[11px] whitespace-nowrap">
                                {p.id}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
